import { getDocs, collection } from 'firebase/firestore'
import { database } from '../firebase'
import type { SparePart } from '@/types'
import { getPartBrands } from './getPartBrands'
import { getPartCategories } from './getPartCategories'

export let cachedParts: SparePart[] = []

export const getParts = async (forceRefresh = false): Promise<SparePart[]> => {
  if (!forceRefresh && cachedParts.length > 0) return cachedParts
  if (!forceRefresh) {
    const stored = localStorage.getItem('cachedParts')
    if (stored) {
      cachedParts = JSON.parse(stored) as SparePart[]
      return cachedParts
    }
  }

  try {
    const [partBrands, categories, partsSnapshot] = await Promise.all([
      getPartBrands(),
      getPartCategories(),
      getDocs(collection(database, 'parts')),
    ])

    if (partsSnapshot.empty) {
      cachedParts = []
      return cachedParts
    }

    const parts = partsSnapshot.docs.map((doc) => {
      const data = doc.data() as Record<string, unknown>
      const brandId = (data.brandId ?? (data.brand as { id?: string } | undefined)?.id) as string | undefined
      const categoryId = (data.categoryId ?? (data.category as { id?: string } | undefined)?.id) as string | undefined
      const brand = brandId ? partBrands.find((b) => b.id === brandId) : undefined
      const category = categoryId ? categories.find((c) => c.id === categoryId) : undefined
      return {
        ...data,
        id: doc.id,
        brand,
        category,
        brandId: brandId ?? brand?.id,
        categoryId: categoryId ?? category?.id,
      } as SparePart
    })

    cachedParts = parts
    localStorage.setItem('cachedParts', JSON.stringify(cachedParts))
    return cachedParts
  } catch (error) {
    console.error('Error al obtener repuestos:', error)
    return []
  }
}
